export enum VenueMetricBatchStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum VenueMetricBatchEvent {
  CREATED = 'VENUE_METRIC_BATCH_CREATED',
  PROCESSING_STARTED = 'VENUE_METRIC_BATCH_PROCESSING_STARTED',
  PROCESSING_COMPLETED = 'VENUE_METRIC_BATCH_PROCESSING_COMPLETED',
  PROCESSING_FAILED = 'VENUE_METRIC_BATCH_PROCESSING_FAILED',
}
